import gql from 'graphql-tag';
import KEYBOARDING_DYNAMIC_CONTENT_FRAGMENT from './KeyboardingDynamicContent';
const PICK_THE_ANSWER_ACTIVITY_FRAGMENT = gql `
  fragment PickTheAnswerActivityFragment on PickTheAnswerActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
        description
      }
    }
    rounds {
      hint {
        id
        audioId
        audio {
          description
          id
          src
          description
        }
      }
      roundInstructions: instructions {
        id
        audioId
        audio {
          description
          id
          src
          description
        }
      }
      questionHtml {
        id
        elements
      }
      optionalContent {
        ...KeyboardingDynamicContentFragment
      }
      sentences {
        fragments {
          textHtml {
            id
            elements
          }
          answers {
            id
            value
            correct
          }
        }
      }
    }
  }
  ${KEYBOARDING_DYNAMIC_CONTENT_FRAGMENT}
`;
export default PICK_THE_ANSWER_ACTIVITY_FRAGMENT;
